import { render, staticRenderFns } from "./editUserForMZ.vue?vue&type=template&id=3c067a70"
import script from "./editUserForMZ.vue?vue&type=script&lang=js"
export * from "./editUserForMZ.vue?vue&type=script&lang=js"
import style0 from "./editUserForMZ.vue?vue&type=style&index=0&id=3c067a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports